import AnimalIcon from '../AnimalIcon';
import ElinorNoPeeking from '../ElinorNoPeeking';

export default class OverlayHidingAlert extends Phaser.Group {
  constructor(game, playerIcon, playerNr) {
    super(game);

    //
    this.onEnd = new Phaser.Signal();

    // background
    const bg = this.game.make.graphics();
    bg.beginFill(0, 0.7);
    bg.drawRect(0, 0, this.game.defaultWidth, this.game.defaultHeight);
    bg.endFill();
    this.addChild(bg);

    // icon
    this.icon = new AnimalIcon(this.game, 0, 165, playerNr, playerIcon);
    this.icon.x = this.game.defaultWidth / 2;
    this.addChild(this.icon);

    //
    // const ind = this.game.controller.twoPlayersModel.hidingPlayerId === 0 ? 2 : 1;
    const elinor = new ElinorNoPeeking(this.game);
    elinor.x = this.game.defaultWidth / 2;
    elinor.y = this.game.defaultHeight;
    this.addChild(elinor);

    //
    if (playerNr === 1) {
      // for player 1
      this.game.twoPlayersOnboarding.playVOs(['ob_05_elinor_025', 'ob_05_elinor_014']);
    } else {
      // for player 2
      this.game.twoPlayersOnboarding.playVOs(['ob_05_elinor_013', 'ob_05_elinor_014']);
    }
    this.game.twoPlayersOnboarding.onEnd.addOnce(this.handleOnboardingEnd, this);
  }

  handleOnboardingEnd() {
    this.game.time.events.add(500, this.close, this);
  }

  close() {
    this.onEnd.dispatch();
  }
}
